import React from 'react';
import styled from 'styled-components';
import StyledText from '../../../components/StyledComponents/StyledText';
import { CorporateTheme } from '../../../utils/themes';

const Card = styled.div`
  background-color: ${CorporateTheme.colors.filterBG};
  padding: 18px 24px;
  border-radius: 5px;
  width: 273px;
`;

const CardTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #1e3a8a;
  margin: 0 0 16px 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const Row = styled.div`
  display: flex;
  gap: 5px;
`;

const Label = styled.span`
  font-size: 14px;
  color: #6b7280;
`;

const Value = styled.span`
  font-size: 14px;
  color: #1f2937;
  font-weight: 500;
`;

interface InfoItem {
    label: string;
    value: string;
}

interface InfoCardProps {
    title: string;
    items: InfoItem[];
}

export const InfoCard: React.FC<InfoCardProps> = ({ title, items }) => {
    return (
        <Card>
            <StyledText fontSize='14px' fontWeight={700} textColor={'var(--app-primary-color)'}>{title}</StyledText>
            <div className='mt-3 d-flex flex-column gap-2'>
                {items.map((item, index) => (
                    <Row key={index}>
                        <StyledText textColor={'var(--app-text-color)'} fontWeight={600} fontSize='13px'>{item.label}:</StyledText>
                        <StyledText textColor={'var(--app-text-color)'} fontWeight={500} fontSize='13px'>{item.value}</StyledText>
                    </Row>
                ))}
            </div>
        </Card>
    );
};